
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/daily-conversation",
      function () {
        return require("private-next-pages/courses/daily-conversation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/daily-conversation"])
      });
    }
  